module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("imAuu"))).then(() => parcelRequire('f4eak'));